/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { css } from '@emotion/react'

import type { UseEuiTheme } from '@elastic/eui'

// This constrains the horizontal rules to the same width as the
// described form groups.
export const externalAuthProviderFormStyle = css({
  maxWidth: 800,
  lineHeight: 1,
})

// Sometimes the form controls in an EuiDescribedFormLayout result
// in there being excess whitespace at the top. This custom `--none`
// class corrects this.
export const euiDescribedFormGroupFieldPaddingNoneStyle = css({
  '.euiDescribedFormGroup__fields': {
    paddingTop: 0,
  },
})

// Make the accordion button more noticeable
export const authProviderAdvancedSettingsAccordionStyle = ({ euiTheme }: UseEuiTheme) =>
  css({
    '.euiAccordion__button': {
      color: euiTheme.colors.link,
    },
  })

// A bit of breathing room before the order icons
export const externalAuthListOrderStyle = ({ euiTheme }: UseEuiTheme) =>
  css({
    display: 'inline-block',
    padding: `0 0 0 ${euiTheme.size.s}`,
  })
